import axios from "../axios"

const systemBotUrl = () => {
    return axios.get(`/telegram/get-telegram-url`)
        .then(response => response.data)
}

const idGetterBotUrl = () => {
    return axios.get(`/telegram/get-telegram-chat-id-url`)
        .then(response => response.data)
}

const setChatId = (form) => {
    return axios.post(`/telegram/set-chat-id`, form)
        .then(response => response.data)
}

const activate = (form) => {
    return axios.post(`/telegram/activate`, form)
        .then(response => response.data)
}

const deleteUserId = () => {
    return axios.delete(`/telegram/delete-chat-id`)
        .then(response => response.data)
}

export default {
    systemBotUrl,
    idGetterBotUrl,
    setChatId,
    activate,
    deleteUserId,
};